import React from 'react'
import { Picture, Attachment, Video } from 'components/icons'
import ProgressBar from 'components/progressBar'

export interface UploadProgressProps {
  blockProps: {
    progress: number
    mediaType: 'image' | 'video' | 'file'
    filename: string
  }
}

const EmbeddedUploadProgress: React.FC<UploadProgressProps> = ({ blockProps }) => {
  const { progress, mediaType, filename } = blockProps

  const getIcon = () => {
    switch (mediaType) {
      case 'image':
        return <Picture className="w-6 h-6" />
      case 'video':
        return <Video className="w-6 h-6" />
      default:
        return <Attachment className="w-6 h-6" />
    }
  }

  const getLabel = () => {
    switch (mediaType) {
      case 'image':
        return 'Image'
      case 'video':
        return 'Video'
      default:
        return 'File'
    }
  }

  return (
    <div contentEditable={false} className="border border-divider rounded p-4 bg-surface-sunken">
      <div className="flex items-center mb-3 gap-2">
        {getIcon()}
        <span className="text-[14px] text-muted">
          Uploading {getLabel()}: {filename}
        </span>
        <span className="font-medium ml-auto text-[14px]">{progress}%</span>
      </div>
      <ProgressBar
        percentage={progress}
        classNames={{
          track: 'h-2 bg-surface-strong',
          fill: 'h-2 bg-green transition-[width] duration-200 ease-in-out'
        }}
      />
    </div>
  )
}

export default EmbeddedUploadProgress
